export default "__VITE_ASSET__Wc8rXrw$__"